import { withStyles } from '@mui/styles';
import ConfirmationModal from './ConfirmationModal';
import styles from './styles';

const Styled = withStyles(styles)(ConfirmationModal);

export default Styled;
